import { useCallback } from 'react'

interface NetworkInformation {
  downlink: number | null
  effectiveType: string | null
  rtt: number | null
  saveData: boolean | null
  online: boolean
}

/**
 * Custom hook that provides information about the network connection.
 * Types for NetworkInformation API is not complete in TypeScript.
 * https://github.com/Microsoft/TypeScript/issues/27186
 *
 * Safari has no plan to support due to privacy concerns.
 * https://www.zdnet.com/article/apple-declined-to-implement-16-web-apis-in-safari-due-to-privacy-concerns/
 */
export const useNetworkInformation = () => {
  const fetchNetworkInfo = useCallback((): NetworkInformation => {
    let networkInfo: NetworkInformation = {
      downlink: null,
      effectiveType: null,
      rtt: null,
      saveData: null,
      online: navigator.onLine,
    }

    if ('connection' in navigator && navigator.connection) {
      const { downlink, effectiveType, rtt, saveData } =
        navigator.connection as NetworkInformation
      networkInfo = {
        downlink,
        effectiveType,
        rtt,
        saveData,
        online: navigator.onLine,
      }
    }

    return networkInfo
  }, [])

  return fetchNetworkInfo
}
